import { render, staticRenderFns } from "./FilterTags.vue?vue&type=template&id=da844b3c&"
import script from "./FilterTags.vue?vue&type=script&lang=ts&"
export * from "./FilterTags.vue?vue&type=script&lang=ts&"
import style0 from "./FilterTags.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports